import React from 'react';
import { isEmpty, cloneDeep, isEqual } from 'lodash';

import List from '@material-ui/core/List';
import AddCircleOutlineIcon from '@material-ui/icons/AddCircleOutline';
import DeleteOutlined from '@material-ui/icons/DeleteOutlined';
import CloseIcon from '@material-ui/icons/Close';
import Modal from '@material-ui/core/Modal';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';

import Route from './Route';
import ACButton from '../../atoms/ACButton';

import styles from './SetRoute.module.scss';

export default class SetRoute extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showAllPossibleRoutes: false,
    };

    this.onChangeShowAllRoutes = this.onChangeShowAllRoutes.bind(this);
  }

  onChangeShowAllRoutes() {
    let { showAllPossibleRoutes } = this.state;
    showAllPossibleRoutes = !showAllPossibleRoutes;
    this.setState({ showAllPossibleRoutes });
  }

  renderRoutes(routes) {
    if (!routes || isEmpty(routes)) return null;
    return (
      <List>
        {routes.map(route => (
          <Route key={route.id} route={route} onSelectRouteFunc={this.props.onSelectRouteFunc} />
        ))}
      </List>
    );
  }

  // Make sure the stop is not a picnic location. If it is, count it as suitable
  // Telly suitable stops with the total number of stops. If they are equal, the route is suitable
  checkIfAllStopsAccomodateAdults(stops, attendeesCount) {
    let adultsOk = false;
    let isPicnic = false;
    let suitableStopCount = 0;

    stops.forEach(stop => {
      if (stop.variables && !isEmpty(stop.variables)) {
        const { variables } = stop;
        if (variables && variables.isPicnic && variables.isPicnic === true) {
          isPicnic = true;
        }
      }
      // To make sure the stop isn't a picnic location
      // FIXME: Nested IF statements
      if (isPicnic === false) {
        if (stop.item && !isEmpty(stop.item)) {
          const { item } = stop;

          if (item && !isEmpty(item.suitables)) {
            const { suitables } = item;
            let suitableAdultsCount = 0;

            // 2020-01-30 If empty adults and child, then consider it match
            if (suitables.length === 1 && isEmpty(suitables[0])) {
              suitableStopCount = stops.length;
            } else {
              suitables.forEach(suitable => {
                if (suitable.adults && suitable.adults >= attendeesCount) {
                  suitableAdultsCount += 1;
                }
              });
              if (suitableAdultsCount > 0) {
                suitableStopCount += 1;
              }
            }
          }
        }
      } else {
        // If it's a picnic location, count it as suitable
        suitableStopCount += 1;
      }
    });
    // If all the stops are suitables
    if (suitableStopCount > 0 && suitableStopCount === stops.length) {
      adultsOk = true;
    }

    return adultsOk;
  }

  // Check for all the routes to see which satisfy the eligibility criteria.
  getRelaventRoutesOnly(relaventRouteCriteria) {
    const { routes = [], attendeesCount = 0 } = this.props;

    const suitableRoutes = [];

    if (!routes || isEmpty(routes)) return null;
    routes.forEach(route => {
      let isPaxMatch = false;
      if (route.stops && !isEmpty(route.stops)) {
        if (relaventRouteCriteria.paxSize === true) {
          //Check if all stops can accomodate at least  minimum of the totalAttendees
          isPaxMatch = this.checkIfAllStopsAccomodateAdults(route.stops, attendeesCount);
          //We have decided to just show all routes for now anyway - operations may change their mind about this later
          isPaxMatch = true;
        }

        // 2020-01-30 Check Provider When
        // TODO: Never do this anymore because route.providersWhens might be set to null
        let { providersWhens } = route;
        if (isEmpty(providersWhens)) {
          providersWhens = [];
        }
        const isDayMatch = providersWhens.some(pw => pw.value === relaventRouteCriteria.bookingDay);

        // 2020-01-30 dietaries requirements check.
        let isDietaryMatch = true;
        const { dietariesRequirements } = relaventRouteCriteria;
        const { itemsDietaries } = route;
        if (dietariesRequirements !== null) {
          // TODO: Figure this one out later, for now just remove it from the compare logic
          delete dietariesRequirements.allergy;
          isDietaryMatch = isEqual(dietariesRequirements, itemsDietaries);
          //We have decided to just show all routes for now anyway - operations may change their mind about this later
          isDietaryMatch = true;
        }

        // If all matched then it is a possible route
        if (isPaxMatch && isDayMatch && isDietaryMatch) {
          suitableRoutes.push(route);
        }
      }
    });

    return suitableRoutes;
  }

  render() {
    let { routes = [], relaventRouteCriteria = {} } = cloneDeep(this.props);
    const { showAllPossibleRoutes } = this.state;

    if (showAllPossibleRoutes === false) {
      routes = this.getRelaventRoutesOnly(relaventRouteCriteria);
    }

    return (
      <Modal open={this.props.isModifying} onClose={this.props.onCloseFunc}>
        <div className={styles.root}>
          <div>
            <div className={styles.fullWidthColumn}>
              <div className={styles.top}>
                <div>
                  <h3>Add Route</h3>
                </div>
                <div>
                  <CloseIcon className={styles.pointerCursor} onClick={this.props.onCloseFunc} />
                </div>
              </div>
              <div>
                {' '}
                <ACButton
                  text={'Clear Booking Route'}
                  icon={<DeleteOutlined />}
                  iconLast={true}
                  onClickFunc={this.props.onClickClearBookingRouteFunc}
                  color="rgb(255, 118, 95)"
                />
              </div>
              <div className={styles.middle}>
                <div>Available Routes</div>
                <div>
                  <ACButton
                    text={'Create New'}
                    icon={<AddCircleOutlineIcon />}
                    iconLast={true}
                    onClickFunc={this.props.onClickAddNewRoute}
                  />
                </div>
              </div>
            </div>
            <div>
            </div>
            <FormControlLabel
              control={
                <Checkbox
                  color="primary"
                  onChange={this.onChangeShowAllRoutes}
                  checked={showAllPossibleRoutes}
                />
              }
              label="Show all possible routes"
            />
            {this.renderRoutes(routes)}
          </div>
        </div>
      </Modal>
    );
  }
}
